import React, { useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/Modal'
import { size } from 'lodash'
import './index.scss'

function CancelingScenarioModal({ open, close, data }) {
  const { onSubmit, selectedRows, selectAll } = data
  const { t } = useTranslation(['Scenario', 'Wizard'])

  const confirmationMsg = useMemo(() => {
    return selectAll
      ? t('Scenario.ScenarioCancel.CANCEL_ALL_SCENARIOS')
      : size(selectedRows) > 1
      ? t('Scenario.ScenarioCancel.CANCEL_SCENARIOS')
      : t('Scenario.ScenarioCancel.CANCEL_SCENARIO')
  }, [selectedRows, selectAll])

  const onCancel = useCallback(() => {
    onSubmit(selectedRows)
    close()
  }, [close, onSubmit, selectedRows])

  return (
    <Modal
      size='sm'
      className='cancel-scenario-modal'
      open={open}
      onRequestClose={close}
      modalHeading={t('Scenario.ScenarioCancel.CANCEL_MODAL_TITLE')}
      onRequestSubmit={onCancel}
      primaryButtonText={t('Scenario.ScenarioCancel.CANCEL')}
      secondaryButtonText={t('Common:Cancel')}
      confirmLoadingMessage={t('Common:Deleting')}
    >
      <h5>{confirmationMsg}</h5>
    </Modal>
  )
}

export default CancelingScenarioModal
